// import { Menu } from '@base-ui/react/menu';
// import { ChevronUpIcon } from 'lucide-react';
import { NavLink, useLocation } from 'react-router';
// import { Link, NavLink, useLocation } from 'react-router';

import { type MenuItem } from '../menu-items.tsx';
// import { isMenuGroup, type MenuItem } from '../menu-items.tsx';

const itemClassName =
  'mx-3 flex items-center gap-1 bg-transparent p-0 text-base leading-normal font-semibold no-underline hover:opacity-70 focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-v1-primary-100 xl:mx-6';

interface TopBarItemProps {
  menuItem: MenuItem;
}

const TopBarItem = ({ menuItem }: TopBarItemProps) => {
  const { search } = useLocation();

  // if (isMenuGroup(menuItem)) {
  //   return (
  //     <Menu.Root>
  //       <Menu.Trigger
  //         className={`group cursor-pointer border-0 text-v1-background-200 ${itemClassName}`}
  //       >
  //         {menuItem.title}
  //         <ChevronUpIcon className="size-4 rotate-180 transition-transform group-data-popup-open:rotate-0" />
  //       </Menu.Trigger>

  //       <Menu.Portal>
  //         {/* High z-index is required to be displayed above the navbar */}
  //         <Menu.Positioner sideOffset={32} align="start" className="z-1300 outline-none">
  //           <Menu.Popup className="w-80 origin-(--transform-origin) overflow-hidden rounded-2xl border border-v1-background-80 bg-white/90 text-v1-background-200 shadow-sm backdrop-blur-sm transition-[transform,opacity] duration-100 ease-out outline-none data-ending-style:scale-98 data-ending-style:opacity-0 data-starting-style:scale-98 data-starting-style:opacity-0">
  //             {menuItem.children.map((item) => (
  //               <Menu.LinkItem
  //                 key={item.title}
  //                 // Defaults to false, which keeps the popup open during client side navigation
  //                 closeOnClick
  //                 render={
  //                   <Link
  //                     to={`${item.href}${search}`}
  //                     prefetch="intent"
  //                     className="flex h-20 items-center gap-4 px-4 no-underline outline-none hover:bg-v1-background-80/40 focus-visible:bg-v1-background-60 [&>svg]:size-5 [&>svg]:shrink-0"
  //                   />
  //                 }
  //               >
  //                 {item.icon}
  //                 <span className="flex min-w-0 flex-col leading-6">
  //                   <span className="text-base font-bold">{item.title}</span>
  //                   {item.description && (
  //                     <span className="text-sm font-normal whitespace-nowrap">{item.description}</span>
  //                   )}
  //                 </span>
  //               </Menu.LinkItem>
  //             ))}
  //           </Menu.Popup>
  //         </Menu.Positioner>
  //       </Menu.Portal>
  //     </Menu.Root>
  //   );
  // }

  return (
    <NavLink
      prefetch="intent"
      to={`${menuItem.href}${search}`}
      className={({ isActive }) =>
        `${itemClassName} ${isActive ? 'text-v1-primary-100' : 'text-v1-background-200'}`
      }
    >
      {menuItem.title}
    </NavLink>
  );
};

export default TopBarItem;
